import Immutable from 'immutable';

import { ACTION_NAMES as ACTIONS } from './actionTypes';
import {
  API_STATES,
  getActiveConversationEmptyStructure,
} from './utils';


const initialState = Immutable.fromJS({
  initialLoadHasExecuted: false,
  activeTab: 'conversations',

  previews: [],
  previewsLoadingState: API_STATES.INITIAL,

  contacts: [],
  contactsLoadingState: API_STATES.INITIAL,
  groupedContacts: {},

  activeConversation: getActiveConversationEmptyStructure(),
  activeConversationPreloadDetails: {
    userId: 0,
    name: '',
    isFriend: false,
    isFavorite: false,
    isFan: false,
  },
  activeConversationLoadingState: API_STATES.INITIAL,
  activeConversationLoadingMoreState: API_STATES.INITIAL,

  createConversationLoadingState: API_STATES.INITIAL,
  deleteConversationLoadingState: API_STATES.INITIAL,
  deleteMessageLoadingState: API_STATES.INITIAL,
  markAsSpamLoadingState: API_STATES.INITIAL,
  banUserLoadingState: API_STATES.INITIAL,

  reportAbuseLoadingState: API_STATES.INITIAL,
  reportAbuseErrorMessage: '',

  groupConversation: getActiveConversationEmptyStructure(),
  groupConversationLoadingState: API_STATES.INITIAL,
  groupConversationLoadingMoreState: API_STATES.INITIAL,

  uploads: {},
});

/* eslint-disable-next-line complexity */
export default function reducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.INITIAL_LOAD_EXECUTED:
      return state
        .set('initialLoadHasExecuted', true);

    case ACTIONS.SET_ACTIVE_TAB:
      return state
        .set('activeTab', payload.activeTab);


    case ACTIONS.SET_PREVIEWS_LOADING:
      return state
        .set('previewsLoadingState', API_STATES.LOADING);

    case ACTIONS.SET_PREVIEWS_LOADING_ERROR:
      return state
        .set('previewsLoadingState', API_STATES.ERROR);

    case ACTIONS.SET_PREVIEWS_LOADING_SUCCESS:
      return state
        .set('previewsLoadingState', API_STATES.INITIAL)
        .set('previews', Immutable.fromJS(payload.previews));

    case ACTIONS.UPDATE_PREVIEWS:
      return state
        .set('previews', Immutable.fromJS(payload.previews));


    case ACTIONS.SET_CONTACTS_LOADING:
      return state
        .set('contactsLoadingState', API_STATES.LOADING);

    case ACTIONS.SET_CONTACTS_LOADING_ERROR:
      return state
        .set('contactsLoadingState', API_STATES.ERROR);

    case ACTIONS.SET_CONTACTS_LOADING_SUCCESS:
      return state
        .set('contactsLoadingState', API_STATES.INITIAL)
        .set('contacts', Immutable.fromJS(payload.contacts))
        .set('groupedContacts', Immutable.fromJS(payload.groupedContacts));


    case ACTIONS.SET_CONVERSATION_LOADING:
      return state
        .set('activeConversationLoadingState', API_STATES.LOADING)
        .set('activeConversationPreloadDetails', Immutable.fromJS(payload.activeConversationPreloadDetails));

    case ACTIONS.SET_CONVERSATION_LOADING_ERROR:
      return state
        .set('activeConversationLoadingState', API_STATES.ERROR);

    case ACTIONS.SET_CONVERSATION_LOADING_SUCCESS:
      return state
        .set('activeConversation', Immutable.fromJS(payload.activeConversation))
        .set('activeConversationLoadingState', API_STATES.INITIAL)
        .set('activeConversationLoadingMoreState', API_STATES.INITIAL);


    case ACTIONS.SET_CONVERSATION_LOADING_MORE:
      return state
        .set('activeConversationLoadingMoreState', API_STATES.LOADING);

    case ACTIONS.SET_CONVERSATION_LOADING_MORE_ERROR:
      return state
        .set('activeConversationLoadingMoreState', API_STATES.ERROR);

    case ACTIONS.SET_CONVERSATION_LOADING_MORE_SUCCESS:
      return state
        .set('activeConversationLoadingMoreState', API_STATES.INITIAL)
        .set('activeConversation', Immutable.fromJS(payload.activeConversation));


    case ACTIONS.CREATE_CONVERSATION_LOADING:
      return state
        .set('createConversationLoadingState', API_STATES.LOADING);

    case ACTIONS.CREATE_CONVERSATION_LOADING_ERROR:
      return state
        .set('createConversationLoadingState', API_STATES.ERROR);

    case ACTIONS.CREATE_CONVERSATION_LOADING_SUCCESS:
      return state
        .set('createConversationLoadingState', API_STATES.INITIAL)
        .set('activeConversationLoadingState', API_STATES.INITIAL)
        .set('activeConversationLoadingMoreState', API_STATES.INITIAL)
        .set('activeConversationPreloadDetails', Immutable.fromJS({}))
        .set('activeConversation', Immutable.fromJS(payload.activeConversation))
        .set('previews', Immutable.fromJS(payload.previews));

    case ACTIONS.RESET_CREATE_CONVERSATION_STATUS:
      return state
        .set('createConversationLoadingState', API_STATES.INITIAL);


    case ACTIONS.DELETE_CONVERSATION_LOADING:
      return state
        .set('deleteConversationLoadingState', API_STATES.LOADING);

    case ACTIONS.DELETE_CONVERSATION_LOADING_ERROR:
      return state
        .set('deleteConversationLoadingState', API_STATES.ERROR);

    case ACTIONS.DELETE_CONVERSATION_LOADING_SUCCESS:
      return state
        .set('deleteConversationLoadingState', API_STATES.INITIAL)
        .set('previews', Immutable.fromJS(payload.previews));

    case ACTIONS.RESET_DELETE_CONVERSATION_STATUS:
      return state
        .set('deleteConversationLoadingState', API_STATES.INITIAL);

    case ACTIONS.INITIALIZE_CONVERSATIONS_TAB:
      return state
        .set('previewsLoadingState', API_STATES.LOADING)
        .set('activeConversationLoadingState', API_STATES.INITIAL)
        .set('activeConversationLoadingMoreState', API_STATES.INITIAL)
        .set('activeConversation', Immutable.fromJS(getActiveConversationEmptyStructure()));

    case ACTIONS.UNSET_CONVERSATION:
      return state
        .set('activeConversationLoadingState', API_STATES.INITIAL)
        .set('activeConversationLoadingMoreState', API_STATES.INITIAL)
        .set('activeConversation', Immutable.fromJS(getActiveConversationEmptyStructure()));


    case ACTIONS.ADD_MESSAGE:
      return state
        .set('activeConversation', Immutable.fromJS(payload.activeConversation))
        .set('previews', Immutable.fromJS(payload.previews));


    case ACTIONS.DELETE_MESSAGE_LOADING:
      return state
        .set('deleteMessageLoadingState', API_STATES.LOADING);

    case ACTIONS.DELETE_MESSAGE_LOADING_ERROR:
      return state
        .set('deleteMessageLoadingState', API_STATES.ERROR);

    case ACTIONS.DELETE_MESSAGE_LOADING_SUCCESS:
      return state
        .set('deleteMessageLoadingState', API_STATES.INITIAL)
        .set('activeConversation', Immutable.fromJS(payload.activeConversation));

    case ACTIONS.RESET_DELETE_MESSAGE_STATUS:
      return state
        .set('deleteMessageLoadingState', API_STATES.INITIAL);


    case ACTIONS.MARK_AS_SPAM_LOADING:
      return state
        .set('markAsSpamLoadingState', API_STATES.LOADING);

    case ACTIONS.MARK_AS_SPAM_LOADING_ERROR:
      return state
        .set('markAsSpamLoadingState', API_STATES.ERROR);

    case ACTIONS.MARK_AS_SPAM_LOADING_SUCCESS:
      return state
        .set('markAsSpamLoadingState', API_STATES.INITIAL);

    case ACTIONS.RESET_MARK_AS_SPAM_STATUS:
      return state
        .set('markAsSpamLoadingState', API_STATES.INITIAL);


    case ACTIONS.SET_BAN_USER_LOADING:
      return state
        .set('banUserLoadingState', API_STATES.LOADING);

    case ACTIONS.SET_BAN_USER_LOADING_ERROR:
      return state
        .set('banUserLoadingState', API_STATES.ERROR);

    case ACTIONS.SET_BAN_USER_LOADING_SUCCESS:
      return state
        .set('banUserLoadingState', API_STATES.INITIAL)
        .set('previews', Immutable.fromJS(payload.previews));

    case ACTIONS.RESET_BAN_USER_STATUS:
      return state
        .set('banUserLoadingState', API_STATES.INITIAL);


    case ACTIONS.UPDATE_UPLOAD_PROGRESS:
      return state
        .set('uploads', Immutable.fromJS(payload.uploads));


    case ACTIONS.SET_REPORT_ABUSE_LOADING:
      return state
        .set('reportAbuseLoadingState', API_STATES.LOADING)
        .set('reportAbuseErrorMessage', '');

    case ACTIONS.SET_REPORT_ABUSE_LOADING_ERROR:
      return state
        .set('reportAbuseLoadingState', API_STATES.ERROR)
        .set('reportAbuseErrorMessage', payload.reportAbuseErrorMessage);

    case ACTIONS.SET_REPORT_ABUSE_LOADING_SUCCESS:
      return state
        .set('reportAbuseLoadingState', API_STATES.INITIAL)
        .set('reportAbuseErrorMessage', '');

    case ACTIONS.RESET_REPORT_ABUSE_STATUS:
      return state
        .set('reportAbuseLoadingState', API_STATES.INITIAL)
        .set('reportAbuseErrorMessage', '');


    case ACTIONS.SET_GROUP_CONVERSATION_LOADING:
      return state
        .set('groupConversationLoadingState', API_STATES.LOADING);

    case ACTIONS.SET_GROUP_CONVERSATION_LOADING_ERROR:
      return state
        .set('groupConversationLoadingState', API_STATES.ERROR);

    case ACTIONS.SET_GROUP_CONVERSATION_LOADING_SUCCESS:
      return state
        .set('groupConversation', Immutable.fromJS(payload.groupConversation))
        .set('groupConversationLoadingState', API_STATES.INITIAL)
        .set('groupConversationLoadingMoreState', API_STATES.INITIAL);


    case ACTIONS.SET_GROUP_CONVERSATION_LOADING_MORE:
      return state
        .set('groupConversationLoadingMoreState', API_STATES.LOADING);

    case ACTIONS.SET_GROUP_CONVERSATION_LOADING_MORE_ERROR:
      return state
        .set('groupConversationLoadingMoreState', API_STATES.ERROR);

    case ACTIONS.SET_GROUP_CONVERSATION_LOADING_MORE_SUCCESS:
      return state
        .set('groupConversationLoadingMoreState', API_STATES.INITIAL)
        .set('groupConversation', Immutable.fromJS(payload.groupConversation));

    case ACTIONS.ADD_GROUP_MESSAGE:
      return state
        .set('groupConversation', Immutable.fromJS(payload.groupConversation));


    default:
      return state;
  }
}

export { NAME, selector } from './selectors';

export { default as actionCreators } from './actions';
